<section class="page-wrapper scroll-container">
  <h1 class="page-title">You have been signed out</h1>
  <button class="btn btn-primary" (click)="login()">Sign In</button>
</section>
